import { render, staticRenderFns } from "./Quote-Terms-Conditions.vue?vue&type=template&id=20004d8c&"
import script from "./Quote-Terms-Conditions.vue?vue&type=script&lang=js&"
export * from "./Quote-Terms-Conditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports